import { gql } from '@/utils/graphql';

export const imagefragment = gql`
	fragment imageFragment on MediaItem {
		altText
		mediaDetails {
			width
			height
		}
		src: relativeUrl
	}
`;
